import React from 'react';
import { createBrowserHistory } from 'history';
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import APP from './tools/AppRoutes';
import Afk from './pages/Master/Afk';
import { SessionProvider } from './pages/Master/SessionProvider';

import Master from './pages/Master/Master';
import Login from './pages/Login/Login';
import Historial from './pages/HistorialRegistros/HistorialRegistros';
import Altas from './pages/AltasPendientes/AltasPendientes';
import DetalleHistorial from './pages/DetalleHistorial/DetalleHistorial';
import FormularioAlta from './pages/FormularioAlta/FormularioAlta';
import ConfigurarRegimenes from './pages/ConfigurarRegimenes/ConfigurarRegimenes';
import DetalleAlta from './pages/DetalleAlta/DetalleAlta';

const history = createBrowserHistory();

function App() {
  const helmetContext = {};
  

  return (
    <div className="App">
        <HelmetProvider context={helmetContext}>
            <Router history={history}>
                <SessionProvider>
                    <Afk />
                    <Switch> 
                        <Route exact path = { APP.FORMULARIOALTA } history = {history} component = { (props) => <Master banner footer={true} session={undefined} children={ <FormularioAlta /> } /> } />  
                        <Route exact path = { APP.INDEX } history = {history} component = { (props) => <Master banner footer={true} session={undefined} children={ <Login /> }/> } />   
                        <Route exact path = { APP.HISTORIAL } history = {history} component = { (props) => <Master navbar banner footer={true} session children={ <Historial /> } /> } />  
                        <Route exact path = { APP.ALTAS } history = {history} component = { (props) => <Master navbar banner footer={true} session children={ <Altas /> } /> } />  
                        <Route exact path = { APP.DETALLEHISTORIAL } history = {history} component = { (props) => <Master navbar banner footer={true} session children={ <DetalleHistorial /> } /> } />  
                        <Route exact path = { APP.DETALLEALTA } history = {history} component = { (props) => <Master navbar banner footer={true} session children={ <DetalleAlta /> } /> } />  
                        <Route exact path = { APP.CONFIGURARREGIMENES } history = {history} component = { (props) => <Master navbar banner footer={true} session children={ <ConfigurarRegimenes /> } /> } />              
                        <Route exact path = { APP.NOTFOUND } history = {history} component = { (props) => <Master banner footer={true} session={undefined} children={ <Login /> }/>} />                                   
                    </Switch> 
                </SessionProvider>
            </Router>
        </HelmetProvider>
    </div>
  );
}

export default App;
